import { pxToRem } from '../../../../utils';
export var inputVariables = function inputVariables(siteVars) {
  return {
    colorDisabled: siteVars.colorScheme.brand.foregroundDisabled,
    colorError: siteVars.colorScheme.red.foreground,
    borderColorError: siteVars.colorScheme.red.background,
    iconPosition: 'absolute',
    iconRight: pxToRem(10),
    iconLeft: pxToRem(9),
    inputPaddingWithIconAtStart: pxToRem(5) + " " + pxToRem(12) + " " + pxToRem(5) + " " + pxToRem(34),
    inputPaddingWithIconAtEnd: pxToRem(5) + " " + pxToRem(35) + " " + pxToRem(5) + " " + pxToRem(12),
    inputPadding: pxToRem(5) + " " + pxToRem(12),
    inputInsideLabelPaddingTop: pxToRem(14),
    borderColor: 'transparent',
    borderRadius: siteVars.borderRadiusMedium,
    borderWidth: "0 0 " + pxToRem(2) + " 0",
    backgroundColor: siteVars.colorScheme.default.background2,
    backgroundColorInverted: siteVars.colorScheme.default.background,
    fontColor: siteVars.colorScheme.default.foreground,
    fontSize: siteVars.fontSizes.medium,
    iconColor: siteVars.colorScheme.default.foreground,
    successfulColor: siteVars.colorScheme.green.foreground,
    inputFocusBorderColor: "transparent transparent " + siteVars.colorScheme.brand.borderFocus1 + " transparent",
    inputFocusBorderRadius: siteVars.borderRadiusMedium + " " + siteVars.borderRadiusMedium + " " + siteVars.borderRadiusSmall + " " + siteVars.borderRadiusSmall,
    placeholderColor: siteVars.colorScheme.default.foreground1
  };
};